import { PremiumSection } from '../shared/PremiumSection'
import { PremiumHeading } from '../shared/PremiumHeading'

const STEPS = [
  {
    name: 'Plan',
    description:
      'Turn the idea into a spec with constraints and acceptance criteria, before any code is generated.',
  },
  {
    name: 'Prompt',
    description:
      'Give the tool the repo knowledge, examples and boundaries it needs so the output is repeatable rather than lucky.',
  },
  {
    name: 'Build',
    description:
      'Work in controlled steps small enough that you can still tell what changed and why.',
  },
  {
    name: 'Review',
    description:
      'Catch weak abstractions, thin tests and security gaps before they are load-bearing.',
  },
  {
    name: 'Ship',
    description: 'Deploy only what held up under review.',
  },
]

export function SolutionSection() {
  return (
    <PremiumSection id="solution" containerClassName="max-w-4xl">
      <PremiumHeading as="h2">The system underneath it</PremiumHeading>
      <p className="mb-10 max-w-2xl leading-relaxed text-[#c3ccc7]">
        The tools will keep changing. This does not. It is what I use on my own
        projects, and what we install on yours in a review.
      </p>

      <ol className="divide-y divide-[#232a26] border-y border-[#232a26]">
        {STEPS.map((step, i) => (
          <li key={step.name} className="flex gap-5 py-5">
            <span className="w-6 shrink-0 pt-0.5 font-mono text-sm text-[#80cca5]">
              {String(i + 1).padStart(2, '0')}
            </span>
            <div>
              <h3 className="mb-1 font-semibold text-[#f0f3f1]">{step.name}</h3>
              <p className="leading-relaxed text-[#c3ccc7]">
                {step.description}
              </p>
            </div>
          </li>
        ))}
      </ol>
    </PremiumSection>
  )
}
